"use client";
import { cva as e } from "class-variance-authority";
import { button as a } from "./button.js";
const d = e("", {
  variants: {
    slot: {
      overlay: [
        "fixed inset-0",
        "bg-overlay-light dark:bg-overlay-dark",
        "data-[state=closed]:hidden",
        "data-[state=open]:animate-fade-in",
        "backdrop-blur-sm overflow-y-auto",
        "place-items-center grid z-overlay"
      ],
      content: [
        "fixed",
        "top-[5%]",
        "left-1/2",
        "translate-x-[-50%]",
        // 'left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2',
        "z-overlay",
        "flex flex-col",
        "w-full",
        // 'w-full max-w-lg',
        "duration-200",
        "text-inherit rounded-md",
        // 'px-6 py-2',
        "bg-white shadow-lg dark:bg-gray-dark-950 dark:shadow-none",
        "focus-visible:outline-none",
        "focus:outline-none",
        "data-[state=closed]:hidden",
        "data-[state=closed]:animate-fade-out",
        "data-[state=open]:animate-fade-in",
        //
        "data-[mobile]:inset-0",
        "data-[mobile]:h-[unset]",
        "data-[mobile]:w-[unset]",
        "data-[mobile]:transform-none",
        "data-[mobile]:rounded-none",
        //
        "[&[data-mobile]>div]:h-full",
        "[&[data-mobile]>div]:max-h-dvh",
        "[&[data-mobile]>div]:max-h-[unset]"
        //
      ],
      header: ["px-6 py-4 text-xl font-semibold flex-0 flex flex-col"],
      close: [
        a({ variant: "ghost", size: "md" }),
        "w-8 h-8 min-w-0",
        "text-lg text-gray-500 dark:text-white-alpha-500",
        "absolute top-2 right-3"
      ],
      body: ["px-6 py-2 flex-1"]
    }
  }
});
export {
  d as modal
};
